/**
 * デジタルサイネージ更新用ダイアログモジュール。
 * @module app/signage/SignageDetailDialog
 */
define([
    'module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/text!./templates/SignageDetailDialog.html',
    'dojo/topic',
    'idis/service/Requester',
    'app/signage/_SignageDialogBase',
    'app/signage/DisplayType',
    // 以下、変数で受けないモジュール
    'idis/view/form/RadioGroup',
    'idis/view/form/WordCountTextarea',
    'idis/view/form/WordCountTextBox',
    'app/view/form/MunicipalitySelector',
    'app/view/form/OrganizationSelector',
    'app/view/form/DisasterSelector',
    'app/view/form/EarthQuakeSelector',
    'app/signage/damagetype/DamageTypeSelector',
    'app/view/form/CustomizableMunicipalitySelector'
], function(module, declare, lang, template, topic, Requester, _SignageDialogBase, DisplayType) {

    return declare(module.id.replace(/\//g, '.'), _SignageDialogBase,
    {
        // テンプレート文字列
        templateString: template,

        constructor: function() {
            this.inherited(arguments);
        },

        buildRendering: function() {
            this.inherited(arguments);
        },
    
        /**
         * ダイアログを初期化する。
         */
        initDialog: function(object) {
            this.reset();
            this.initForm(object);
            this.screenId.innerHTML = this._screenId;
            this.initSearchSelector(object.displayType);

            this.own(topic.subscribe(this.DAMAGE_TYPE_SELECTED, lang.hitch(this, function (data) {
                this.setDamageType(data);
            })));

            this.own(topic.subscribe(this.DAMAGE_TYPE_RELEASED, lang.hitch(this, function (data) {
                this.releaseDamageType(data);
            })));
        },

        /**
         * フォームを初期化する。
         */
        initForm: function (object) {
            this._screenId = object.screenId;
            // ディスプレイ種別にモデルをセット
            this.displayType.set('store', DisplayType);
            // 日付のセレクトボックスを生成する
            this.setDateSelect();
            // 時間のセレクトボックスを生成する
            this.setTimeSelect();
            // 被害の種類を初期化
            this.innerDamageTypeSelector.release();

            Requester.get('/api/signage/' + this._screenId).then(lang.hitch(this,function(data) {
                var item = data;
                this._version = item.version;
                this.displayName.set('value', item.displayName);
                this.displayType.set('value', item.displayType);
                this.updFreq.set('value', item.updFreq);
                this.remarks.set('value', item.remarks);
                if (item.disasterId !== null) {
                    this.disasterId.set('value', item.disasterId);
                }
                if (item.municipalityCd !== null) {
                    this.municipalityCd.set('value', item.municipalityCd);
                }
                if (item.organizationCd !== null) {
                    this.organizationCd.set('value', item.organizationCd);
                }
                if (item.notifyDist !== null) {
                    this.notifyDist.set('value', item.notifyDist);
                }
                if (item.hldStatus !== null) {
                    this.hldStatus.set('value', item.hldStatus);
                }
                // if (item.lifelineKindCd !== null) {
                //     this.lifelineKindCd.set('value', item.lifelineKindCd);
                // }
                if (item.notifyType !== null) {
                    this.notifyType.set('value', item.notifyType);
                }
                if (item.reportedStatus !== null) {
                    this.reportedStatus.set('value', item.reportedStatus);
                }
                if (item.shelterStatus !== null) {
                    this.shelterStatus.set('value', item.shelterStatus);
                }
                if (item.chronologyType !== null) {
                    this.chronologyType.set('value', item.chronologyType);
                }
                // if (item.region !== null) {
                //     this.region.set('value', item.region);
                // }
                if (item.urgencyType !== null) {
                    this.urgencyType.set('value', item.urgencyType);
                }
                if (item.earthQuake !== null) {
                    this.earthQuake.set('value', item.earthQuake);
                }
                if (item.riverLevel !== null) {
                    this.riverLevel.set('value', item.riverLevel);
                }
                if (item.municipalityCd !== null) {
                    this.customizableMunicipalityCd.set('value', item.municipalityCd);
                }
                if (item.region !== null) {
                    this.customizableMunicipalityCd.set('value', item.region);
                }
                if (item.startTimestamp !== null) {
                    this.startTimestamp.set('value', item.startTimestamp);
                }
                if (item.endTimestamp !== null) {
                    this.endTimestamp.set('value', item.endTimestamp);
                }
                if (item.damageTypeList !== null) {
                    this.innerDamageTypeSelector.resetDamageType();
                    var damageTypeArr = item.damageTypeList.split(',');
                    this.innerDamageTypeSelector.setDamageType(damageTypeArr);
                }
                if (item.dateSelect !== null) {
                    this.dateSelect.set('value', item.dateSelect);
                }
                if (item.timeSelect !== null) {
                    this.timeSelect.set('value', item.timeSelect);
                }
            }));

        },

        /**
         * 更新する。
         */
        onSubmit: function() {
            try {
                // フォームのバリデーションを実施
                if (!this.form.validate()) {
                    return false;
                }
                // 固有のバリデーションを実施
                if (!this.validate()) {
                    return false;
                }
                var value = this.form.get('value');
                value.screenId = this._screenId;
                value.version = this._version;
                value.damageTypeList = this._damageTypeList;
                this.emit('update', { value: value });
            } catch (e) {
                console.error(e);
            }
            return false;
        },

        /**
         * 削除する。
         */
        onDelete: function() {
            try {
				var value = this.form.get('value');
                value.screenId = this._screenId;
				value.version = this._version;
				this.emit('remove', { value: value });
            } catch (e) {
                console.error(e);
            }
            return false;
        }
    });
});
